import { ReactElement, useContext } from 'react';
import { InfoGroup } from '@/components/molecules';
import { SimpleLayout } from '@/layouts';
import { Carousel } from '@/components/organisms';
import { StudentContext } from '@/contexts';

type CarouselInstructionsType = {
  handleClick: () => void;
};

function CarouselInstructions(props: CarouselInstructionsType): ReactElement {
  const { handleClick } = props;
  const { state } = useContext(StudentContext);
  const paymentName =
    state.paymentMethod === 'fifteen_delay'
      ? 'Pagamento Facilitado com Carência'
      : 'financiamento do Modelo de Sucesso Compartilhado';

  return (
    <SimpleLayout>
      <div className="carousel-instruction-container">
        <div className="carousel-instruction-container__info-group">
          <InfoGroup
            title={<>Seu financiamento em 4 passos</>}
            description={
              <>
                É simples! Basta cadastrar seus dados e da(s) sua(s) pessoa(s)
                avalista(s) para pedir seu {paymentName}.
              </>
            }
            buttonName="Começar"
            handleClick={handleClick}
          />
        </div>
        <div className="carousel-instruction-container__carousel-div">
          <Carousel />
        </div>
      </div>
    </SimpleLayout>
  );
}

export default CarouselInstructions;
